import { PageRequest } from '@/core/request/PageRequest';
import { API_BASE_URL } from '..';
import api from '@/api';
import { PageResult } from '@/core/request/PageResult';
import {
  ResourceLimitationPeriod,
  ResourceLimitationPeriodsCreateRequest,
} from './ResourceLimitationPeriods.types';

const CONTROLLER_URL = `${API_BASE_URL}/resource-limitation-periods`;

export async function listResourceLimitationPeriods(params?: PageRequest) {
  const result = (await api.get(CONTROLLER_URL, params)) as unknown;

  return result as PageResult<ResourceLimitationPeriod>;
}

export async function getResourceLimitationPeriod(
  id: number,
): Promise<ResourceLimitationPeriod> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as ResourceLimitationPeriod;
}

export async function createResourceLimitationPeriod(
  obj: ResourceLimitationPeriodsCreateRequest,
) {
  const result = (await api.post(CONTROLLER_URL, obj, null)) as unknown;

  return result as ResourceLimitationPeriod;
}

export async function deleteResourceLimitationPeriod(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
